import {Component,ChangeDetectorRef,ElementRef,Input,OnInit,TemplateRef,ViewChild,AfterViewInit,} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { ProgressBarModule } from 'primeng/progressbar';
import { TabsModule } from 'primeng/tabs';

// Importando os componentes standalone que j├í foram convertidos
import { AtividadeFormComponent } from '../atividade-form/atividade-form.component';
import { AtividadeAnexosComponent } from '../atividade-anexos/atividade-anexos.component';
import { AtividadeMateriaisComponent } from '../atividade-materiais/atividade-materiais.component';
import { AtividadeServicosComponent } from '../atividade-servicos/atividade-servicos.component';
import { AtividadeCheckListComponent } from '../atividade-checklist/atividade-checklist.component';
import { AtividadeMensagensComponent } from '../atividade-mensagens/atividade-mensagens.component';
import { AtividadeManobrasComponent } from '../atividade-manobras/atividade-manobras.component';
import { AtividadeOsVinculadaComponent } from '../atividade-os-vinculada/atividade-os-vinculada.component';
import { ToiDetalheComponent } from '@/features/toi/toi-detalhe/toi-detalhe.component';
import { ToiService } from '@/features/toi/toi.service';
import { ToiExportPdfService } from '@/features/toi/toi-export-pdf.service';
import { ToiExportPdfComponent } from '@/features/toi/toi-export-pdf/toi-export-pdf.component';
import { ToiDetalhe } from '@/features/toi/models/toi-detalhe.model';
import { PdfToiResponse } from '@/features/toi/models/pdf-toi.model';
import { ToiDetalheSavedEvent } from '@/features/toi/models/toi-pdf-upload.model';
import { usuarioPodeConsultarToi } from '@/features/toi/utils/toi-permissao.util';

import { AtividadeCheckListService } from '../atividade-checklist/atividade-checklist.service';
import { AtividadeCheckList } from '../models/atividade-checklist';
// import 'jspdf-barcode'; // Pacote n├úo instalado - comentado temporariamente
import jsPDF from 'jspdf';
import moment from 'moment';
import autoTable from 'jspdf-autotable';
import { AtividadeMateriaisService } from '../atividade-materiais/atividade-materiais.service';
import { AtividadeServicosService } from '../atividade-servicos/atividade-servicos.service';
import { forkJoin } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { MessageService } from 'primeng/api';
import JsBarcode from 'jsbarcode';
import { UserService } from '@/core/service/user.service';
declare module 'jspdf' {
  interface jsPDF {
    lastAutoTable: {
      finalY: number;
    };
  }
}

@Component({
    selector: 'max-atividade-tabs',
    templateUrl: './atividade-tabs.component.html',
    styleUrls: ['./atividade-tabs.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        TabsModule,
        ProgressBarModule,
        // Componentes standalone já convertidos
        AtividadeFormComponent,
        AtividadeAnexosComponent,
        AtividadeMateriaisComponent,
        AtividadeServicosComponent,
        AtividadeCheckListComponent,
        AtividadeMensagensComponent,
        AtividadeManobrasComponent,
        AtividadeOsVinculadaComponent,
        ToiDetalheComponent,
        ToiExportPdfComponent,
    ],
    providers: [MessageService, ToiExportPdfService]
})
export class AtividadeTabsComponent implements OnInit {
  atividadeCheckLists: AtividadeCheckList[] = [];
  @Input() idAtividade: number = 0;
  tabs: any[] = [];
  activeIndex: number = 0;
  value: number = 0;
  activeTabValue: string = '0';
  flagConAnexo: boolean = false;
  flagConCkl: boolean = false;
  flagConServicos: boolean = false;
  flagConMateriais: boolean = false;
  flagConMensagem: boolean = false;
  flagConAtividadeComplementar: boolean = false;
  flagConManobras: boolean = false;
  flagConToi: boolean = false;
  progress: boolean = true;
  showImages: boolean = false;
  detalheToi: ToiDetalhe | null = null;
  pdfToi: PdfToiResponse | null = null;
  loadingToi: boolean = true;
  /** Evita refazer a busca do TOI quando o form recarrega o detalhe (ex.: ajuste de coordenadas). */
  private toiRequisitado = false;
  /** Conjunto de IDs de mídias do TOI ocultas no PDF (estado local da sessão de edição). */
  midiasOcultasPdf: Set<string> = new Set<string>();
  readonly midiasOcultasPdfOficial = new Set<string>();
  mostrarHtmlParaPdfToi = false;
  renderPdfOficial = false;

  @ViewChild(AtividadeFormComponent) atividadeForm!: AtividadeFormComponent;
  @ViewChild(AtividadeCheckListComponent) atividadeChecklist!: AtividadeCheckListComponent; //
  dadosMat: any;
  dadosServ: any;

  onToiDetalheVoltar(): void {
    this.activeTabValue = '0';
    this.fecharDialogPai();
  }

  exportarToiPdf(): void {
    this.toiExportPdfService.exportarPdf(
      this.pdfToi,
      this.midiasOcultasPdf,
      this.detalheToi,
      () => this.prepararElementoPdfToi(),
      () => this.finalizarRenderPdfToi()
    );
  }

  onToiDetalheSalvo(event?: ToiDetalheSavedEvent): void {
    // TOI aprovado: gera o PDF oficial e envia ao backend (SalvarPdf) para uso no envio e-Carta.
    if (event?.motivo === 'aprovacao') {
      this.recarregarToiEEnviarPdf('TOI aprovado');
      return;
    }

    this.getAtividadeToi();
  }

  private async prepararElementoPdfToi(oficial = false): Promise<HTMLElement | null> {
    this.renderPdfOficial = oficial;
    this.mostrarHtmlParaPdfToi = true;
    this.cd.detectChanges();

    await new Promise((resolve) => setTimeout(resolve, 300));
    await new Promise((resolve) => requestAnimationFrame(resolve));

    return document.getElementById('conteudoParaPdfToi');
  }

  private finalizarRenderPdfToi(): void {
    this.mostrarHtmlParaPdfToi = false;
    this.renderPdfOficial = false;
    this.cd.detectChanges();
  }

  /**
   * Recarrega os dados do TOI (já com a alteração aplicada), gera o PDF oficial e envia ao
   * backend (SalvarPdf). `acao` compõe as mensagens, ex.: 'TOI aprovado'.
   */
  private recarregarToiEEnviarPdf(acao: string): void {
    const avisarFalhaCarregamento = (): void => {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: `${acao}, mas não foi possível carregar os dados para gerar o PDF.`,
        life: 5000,
      });
    };

    this.loadingToi = true;
    this.toiService
      .getAtividadeToiData(this.idAtividade)
      .pipe(finalize(() => (this.loadingToi = false)))
      .subscribe({
        next: ({ pdfToi, detalhe }) => {
          this.pdfToi = pdfToi;
          this.detalheToi = detalhe;
          this.cd.detectChanges();

          if (!pdfToi || !detalhe?.idAtividadeToi) {
            avisarFalhaCarregamento();
            return;
          }

          void this.toiExportPdfService.gerarEEnviarPdfOficial({
            idAtividadeToi: detalhe.idAtividadeToi,
            pdfToi,
            detalhe,
            prepararElemento: () => this.prepararElementoPdfToi(true),
            finalizarRender: () => this.finalizarRenderPdfToi(),
            mensagemSucessoNegocio: `${acao} com sucesso.`,
          });
        },
        error: () => avisarFalhaCarregamento(),
      });
  }


  private fecharDialogPai(): void {
    const host = this.elementRef.nativeElement as HTMLElement;
    const dialogEl = host.closest('p-dialog');
    if (!dialogEl) {
      return;
    }

    const closeBtn = dialogEl.querySelector<HTMLButtonElement>(
      '.p-dialog-close-button, .p-dialog-header-close, button[aria-label="Close"]'
    );
    closeBtn?.click();
  }

  onTabChange(event: any) {
    const tabValue = event?.toString() || '';
    const isChecklistTab = tabValue.startsWith('tab-');
    this.showImages = isChecklistTab;
    console.log('Tab value:', tabValue, 'isChecklistTab:', isChecklistTab, 'showImages:', this.showImages);
  }

  setImages(value: boolean) {
    this.showImages = value;
    console.log('setImages called:', value);
  }

  constructor(
    private atividadeCheckListService: AtividadeCheckListService,
    private activatedRoute: ActivatedRoute,
    private atividadeMateriaisService: AtividadeMateriaisService,
    private atividadeServicosService: AtividadeServicosService,
    private messageService: MessageService,
    private userService: UserService,
    private readonly toiService: ToiService,
    private readonly toiExportPdfService: ToiExportPdfService,
    private readonly elementRef: ElementRef<HTMLElement>,
    private readonly cd: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.progress = true
    this.flagConAnexo =
      this.userService.hasPermission('WFM_ATIVIDADE_ANEXO_CON') || this.userService.hasPermission('Admin');
    this.flagConCkl =
      this.userService.hasPermission('WFM_ATIVIDADE_EDT') || this.userService.hasPermission('Admin');
    this.flagConServicos =
      this.userService.hasPermission('WFM_ATIVIDADE_CON') || this.userService.hasPermission('Admin');
    this.flagConMateriais =
      this.userService.hasPermission('WFM_ATIVIDADE_CON') || this.userService.hasPermission('Admin');
    this.flagConMensagem =
      this.userService.hasPermission('WFM_MENSAGEM_CON') || this.userService.hasPermission('Admin');
    this.flagConAtividadeComplementar =
      this.userService.hasPermission('WFM_ATIVIDADE_COMPLEMENTAR_CON') ||
      this.userService.hasPermission('Admin');
    this.flagConManobras =
      this.userService.hasPermission('WFM_ATIVIDADE_REGISTROS_CON') ||
      this.userService.hasPermission('Admin');

    // Prioriza o @Input, depois tenta pegar da rota
    if (this.idAtividade === null || this.idAtividade === undefined || this.idAtividade === 0) {
      const routeId = this.activatedRoute.snapshot.params['idAtividade'];
      this.idAtividade = routeId;
    }

    if (this.idAtividade) {
      this.getCheckLists();
    } else {
      this.progress = false;
    }
  } 

  /**
   * Recebe o `ToiAtivo` do DetalheAtividade (já carregado pelo form).
   * Sem a permissão MXL_ATIVIDADE_TOI_CON (ou quando a flag vier false),
   * nenhuma requisição ao TOI é feita e a aba não é exibida.
   */
  onToiAtivoChange(toiAtivo: boolean): void {
    const permiteConsultaToi = usuarioPodeConsultarToi((role) => this.userService.hasPermission(role));
    if (!permiteConsultaToi || !toiAtivo) {
      this.flagConToi = false;
      this.loadingToi = false;
      return;
    }
    if (this.toiRequisitado) {
      return;
    }
    this.toiRequisitado = true;
    this.getAtividadeToi();
  }

  getAtividadeToi() {
    this.loadingToi = true;

    // Um único GET v3/MxlAtividadeToi/PorAtividade/{id} alimenta o detalhe e o PDF.
    this.toiService.getAtividadeToiData(this.idAtividade).subscribe({
      next: ({ pdfToi, detalhe }) => {
        this.pdfToi = pdfToi;
        this.detalheToi = detalhe;
        this.flagConToi = usuarioPodeConsultarToi((role) => this.userService.hasPermission(role));
        this.loadingToi = false;
      },
      error: () => {
        this.flagConToi = false;
        this.loadingToi = false;
      },
    });
  }

  getCheckLists() {
    this.atividadeCheckListService.getAtividadeCheckLists(this.idAtividade).subscribe({
      next: (atvCheckLists) => {
        this.atividadeCheckLists = atvCheckLists;
        setTimeout(() => {
        const dados = this.atividadeForm?.obterDadosFormulario();
        const codigoServico = dados?.siglaAtvTipo;
        console.log('Validando pelo Código de Serviço:', codigoServico);
      }, 600);
        let icon: string;
        const tabsLength = atvCheckLists.length;
        const porcentagemTabsCarregadas = tabsLength > 0 ? 100 / tabsLength : 100;
        this.value = tabsLength == 0 ? 100 : 0;

        for (let j = 0; j < tabsLength; j++) {
          icon = this.getIconCheckList(atvCheckLists[j].template);
          this.tabs.push({
            id: j + 1,
            header: atvCheckLists[j].template,
            icon,
            checkListTipoAtividades: atvCheckLists[j].checkListTipoAtividades,
            atvCheckList: atvCheckLists[j],
          });
          const tpl = (atvCheckLists[j].template ?? '').toLowerCase();
          if (tpl.includes('baixa')) {
            const fields = atvCheckLists[j].checkListTipoAtividades?.fields ?? [];
            const fotos = fields.filter(
              (f: { type?: string }) => f.type === 'Foto' || f.type === 'Foto IA'
            );
            console.log('[atividade-tabs] Baixa ÔÇö resposta getAtividadeCheckLists (API)', {
              template: atvCheckLists[j].template,
              fotos,
              fields
            });
          }
          const interval = setInterval(() => {
            this.value = this.value + Math.floor(porcentagemTabsCarregadas) + 1;
            if (this.value >= 100 || j == tabsLength - 1) {
              this.value = 100;
              clearInterval(interval);
              this.progress = false;
            }
          }, 1000);

          this.activeIndex = 0;
        }

        this.progress = false;
      },
      error: (error) => {
        this.progress = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Erro ao carregar dados da atividade',
          life: 3000
        });
      }
    });
  }

  getIconCheckList(template: string): string {
    if (template.toLowerCase().indexOf('fotos') >= 0) {
      return 'pi pi-camera';
    } else if (template.toLowerCase().indexOf('baixa') >= 0) {
      return 'pi pi-list';
    } else if (template.toLowerCase().indexOf('paralisa├º├úo') >= 0) {
      return 'pi pi-ban';
    } else if (template.toLowerCase().indexOf('pend├¬ncia') >= 0) {
      return 'pi pi-times';
    } else {
      return '';
    }
  }

  //#region Código de Barras
  private async adicionarCodigoBarrasViaImagem(
    doc: jsPDF,
    numeroOS: string,
    x: number,
    y: number,
    width: number,
    height: number
  ) {
    const canvas = document.createElement('canvas');

    JsBarcode(canvas, numeroOS, {
      format: 'CODE128',
      width: 2,
      height: 70,
      displayValue: false,
      text: numeroOS,
      fontOptions: 'bold',
      textMargin: 5,
      fontSize: 14,
    });
    const imgData = canvas.toDataURL('image/png');
    doc.addImage(imgData, 'PNG', x, y, width, height);
    await new Promise((resolve) => setTimeout(resolve, 50));
  }
  //#endregion

  transformPDF(event: boolean) {
    if (event) {
      this.exibirMensagemAguarde(true);
      // Quando a geração do PDF passar a incluir as mídias do TOI,
      // usar `this.midiasOcultasPdf` (Set<string>) para filtrar as fotos marcadas como ocultas
      // pelo usuário no modo edição (estado local, não persistido).
      const doc = new jsPDF({
        orientation: 'p',
        unit: 'pt',
        format: 'a4',
        compress: true,
      });

      forkJoin({
        atvMateriais: this.atividadeMateriaisService.getAtividadeMateriais(this.idAtividade),
        atvServicos: this.atividadeServicosService.getAtividadeServicosAplicados(this.idAtividade),
      }).subscribe({
        next: (result) => {
          this.dadosMat = result.atvMateriais;
          this.dadosServ = result.atvServicos;

          const dadosForm = this.atividadeForm?.obterDadosFormulario();
          const dadosChecklist =
            this.tabs.find((tab) => tab.header === 'Baixa')?.checkListTipoAtividades?.fields || [];

          if (dadosForm.inicioExecucaoReal) {
            dadosChecklist.unshift(
              {
                labelNovaAba: 'In├¡cio Execu├º├úo Real'.toUpperCase(),
                valor:
                  new Date(dadosForm.inicioExecucaoReal).toLocaleDateString('pt-BR') +
                  ' ' +
                  new Date(dadosForm.inicioExecucaoReal).toLocaleTimeString('pt-BR', {
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit',
                  }),
              },
              {
                labelNovaAba: 'Fim Execu├º├úo Real'.toUpperCase(),
                valor:
                  new Date(dadosForm.fimExecucaoReal).toLocaleDateString('pt-BR') +
                  ' ' +
                  new Date(dadosForm.fimExecucaoReal).toLocaleTimeString('pt-BR', {
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit',
                  }),
              }
            );
          }
          this.gerarPDF(doc, dadosForm, dadosChecklist);
          this.exibirMensagemAguarde(false);
        },
        error: (err) => {
          this.exibirMensagemAguarde(false);
        },
      });
    }
  }

  exibirMensagemAguarde(exibir: boolean) {
    if (exibir) {
      this.messageService.add({
        severity: 'info',
        summary: 'Aguarde',
        detail: 'Gerando PDF, por favor, aguarde...',
      });
    } else {
      this.messageService.clear();
    }
  }

  gerarPDF(doc: jsPDF, dadosForm: any, dadosChecklist: any) {
    const margin = 10;
    const pageWidth = doc.internal.pageSize.getWidth();
    const totalWidth = pageWidth - 2 * margin;

    const boxWidth = totalWidth * 0.9;
    const caixaAltura = 250;
    const numLinhas = 5;
    const alturaLinha = caixaAltura / numLinhas;

    let posY = 80;

    const imgEsquerdaPath = '../../assets/layout/images/copasa.png';
    const imgDireitaPath = '../../assets/layout/images/sigos.png';

    this.addImagesToPDF(doc, imgEsquerdaPath, imgDireitaPath).then(() => {
      doc.setFont('Helvetica');
      doc.setFontSize(12);
      doc.text('Ordem de Servi├ºo (OS)', pageWidth / 2, 60, { align: 'center' });

      const boxX = margin + (totalWidth - boxWidth) / 2;
      doc.rect(boxX, posY, boxWidth, caixaAltura);
      posY += 5;

      doc.setDrawColor(169, 169, 169);
      doc.setTextColor(0, 0, 255);
      //#region Popular Tabelas
      //  Converter Economia por Categoria
      const TableEconomCategoria = dadosForm.tableEconomCategoria.map((item: any) => [
        item[0] === 'AGUA' ? 'A' : 'E',
        item[1],
        item[2],
        item[3],
        item[4],
        item[5],
      ]);
      //  Converter Resumo do PS
      const tableResumoPS = dadosForm.tableResumoPS.map((item: any) => [item[0], item[1], item[2]]);

      //  Converter Leitura Imovel
      const tableLeituraImovel = dadosForm.tableLeituraImovel.map((item: any) => [
        item[0],
        item[1].split(' ')[0],
        item[2],
        item[3],
        item[4],
        item[5],
        item[6],
      ]);

      //Informa├º├Áes Adicionais
      const TableInfoAdicional = [[dadosForm.infoAdicionais]];

      //D├®bitos
      const tableDebitos = dadosForm.tableDebitos.map((item: any) => [
        item[0],
        new Date(item[1]).toLocaleDateString('pt-BR'),
        item[2].toString().replace('.', ','),
      ]);

      //Aba Checklist
      const tableChecklist = dadosChecklist
        .filter((item: any) => item.labelNovaAba != null && item.labelNovaAba != undefined && !item.labelNovaAba.toLowerCase().match(/^foto/))
        .map((item: any) => [
          item.labelNovaAba,
          item.valor === 'true' ? 'Sim' : item.valor === 'false' ? 'N├úo' : item.valor,
        ]);

      //Aba Materiais Aplicados
      const tableAtividadeMat = this.dadosMat.map((item: any) => [
        item.codigoInterno,
        item.descricaoMaterial,
        item.quantidade,
        item.unidadeMaterial,
      ]);

      //Aba Servi├ºos Aplicados
      const tableServAplicados = this.dadosServ.map((item: any) => [
        item.descricaoLocal,
        item.descricaoPavimentacao,
        item.comprimento,
        item.largura,
        item.profundidade,
        item.profundidadePl,
        item.profundidadeRede,
        item.profundidadePv,
        item.reaterro,
        item.observacao,
      ]);

      //Assinaturas
      const tableAssinaturas: any[] = [];

      //#endregion
      //#region Geral
      const colWidth1 = boxWidth * 0.2;
      const colWidth2 = boxWidth * 0.1;
      const colWidth3 = boxWidth * 0.45;
      const colWidth4 = boxWidth * 0.1;
      const colWidth5 = boxWidth * 0.15;

      this.adicionarCaixaTexto(
        doc,
        'N├║mero da OS',
        String(dadosForm.numeroBA),
        boxX,
        posY,
        colWidth1,
        alturaLinha
      );
      const barcodeHeight = 20;
      const barcodeWidth = colWidth1 * 0.9;
      this.adicionarCodigoBarrasViaImagem(
        doc,
        String(dadosForm.numeroBA),
        boxX + 2,
        posY + alturaLinha + -26,
        barcodeWidth,
        barcodeHeight
      );
      this.adicionarCaixaTexto(
        doc,
        'C├│digo',
        String(dadosForm.siglaAtvTipo),
        boxX + colWidth1,
        posY,
        colWidth2,
        alturaLinha
      );
      this.adicionarCaixaTexto(
        doc,
        'Descri├º├úo do Servi├ºo',
        String(dadosForm.descTipoAtividade),
        boxX + colWidth1 + colWidth2,
        posY,
        colWidth3,
        alturaLinha
      );
      this.adicionarCaixaTexto(
        doc,
        'Unidade',
        String(dadosForm.unidadeOrg),
        boxX + colWidth1 + colWidth2 + colWidth3,
        posY,
        colWidth4,
        alturaLinha
      );
      this.adicionarCaixaTexto(
        doc,
        'Status OS',
        String(dadosForm.status),
        boxX + colWidth1 + colWidth2 + colWidth3 + colWidth4,
        posY,
        colWidth5,
        alturaLinha
      );
      posY += alturaLinha;

      const colWidth6 = boxWidth * 0.2;
      const colWidth7 = boxWidth * 0.5;
      const colWidth8 = boxWidth * 0.3;
      this.adicionarCaixaTexto(
        doc,
        'Matr├¡cula Im├│vel',
        String(dadosForm.matricula_Imovel),
        boxX,
        posY,
        colWidth6,
        alturaLinha
      );
      this.adicionarCaixaTexto(
        doc,
        'Cliente',
        String(dadosForm.cliente),
        boxX + colWidth6,
        posY,
        colWidth7,
        alturaLinha
      );
      this.adicionarCaixaTexto(
        doc,
        'Data da Gera├º├úo',
        String(dadosForm.geracaoOS),
        boxX + colWidth6 + colWidth7,
        posY,
        colWidth8,
        alturaLinha
      );
      posY += alturaLinha;

      const colWidth9 = boxWidth * 0.7;
      const colWidth10 = boxWidth * 0.3;
      this.adicionarCaixaTexto(
        doc,
        'Endere├ºo',
        String(dadosForm.endereco),
        boxX,
        posY,
        colWidth9,
        alturaLinha
      );
      this.adicionarCaixaTexto(
        doc,
        'Data Limite Atendimento',
        String(dadosForm.limiteAtendimento),
        boxX + colWidth9,
        posY,
        colWidth10,
        alturaLinha
      );
      posY += alturaLinha;

      const colWidth11 = boxWidth * 0.2;
      const colWidth12 = boxWidth * 0.3;
      const colWidth13 = boxWidth * 0.3;
      const colWidth14 = boxWidth * 0.2;
      this.adicionarCaixaTexto(
        doc,
        'Refer├¬ncia',
        String(dadosForm.referencia),
        boxX,
        posY,
        colWidth11,
        alturaLinha
      );
      this.adicionarCaixaTexto(
        doc,
        'Solicitante',
        String(dadosForm.solicitante),
        boxX + colWidth11,
        posY,
        colWidth12,
        alturaLinha
      );
      this.adicionarCaixaTexto(
        doc,
        'Tel. Solicitante',
        String(dadosForm.tel_Solicitante),
        boxX + colWidth11 + colWidth12,
        posY,
        colWidth13,
        alturaLinha
      );
      this.adicionarCaixaTexto(
        doc,
        'Equipe',
        String(dadosForm.equipe + ' - ' + dadosForm.responsavel),
        boxX + colWidth11 + colWidth12 + colWidth13,
        posY,
        colWidth14,
        alturaLinha
      );
      posY += alturaLinha;

      const colWidth15 = boxWidth * 0.5;
      const colWidth16 = boxWidth * 0.5;
      this.adicionarCaixaTexto(
        doc,
        'Identificador do Cliente',
        String(dadosForm.identificadorCliente),
        boxX,
        posY,
        colWidth15,
        alturaLinha
      );
      this.adicionarCaixaTexto(
        doc,
        'Setor-Rota-Face-Seq',
        String(dadosForm.setorRotaFaceSeq),
        boxX + colWidth15,
        posY,
        colWidth16,
        alturaLinha
      );
      posY += alturaLinha + 20;
      //#endregion
      //#region Dados da Instala├º├úo
      const caixaAltura2 = alturaLinha * 0.3;
      const boxX2 = margin + (totalWidth - boxWidth) / 2;
      doc.setFillColor(242, 242, 242);
      doc.rect(boxX2, posY, boxWidth, caixaAltura2, 'F');
      doc.setDrawColor(169, 169, 169);
      doc.setLineWidth(0.5);
      doc.rect(boxX2, posY, boxWidth, caixaAltura2);
      posY += caixaAltura2;
      doc.setTextColor(1, 130, 214);
      const padding = 30;
      const ajusteVertical = -5;
      doc.text('Dados da Instala├º├úo', margin + padding, posY + ajusteVertical, { align: 'left' });

      posY += 5;

      const colWidth17 = boxWidth * 0.2;
      const colWidth18 = boxWidth * 0.2;
      const colWidth19 = boxWidth * 0.2;
      const colWidth20 = boxWidth * 0.2;
      const colWidth21 = boxWidth * 0.2;

      this.adicionarCaixaTexto(
        doc,
        'TPS Execu├º├úo',
        String(dadosForm.tpSdeExecucao),
        boxX2,
        posY,
        colWidth17,
        alturaLinha
      );
      this.adicionarCaixaTexto(
        doc,
        'N├║mero do PS',
        String(dadosForm.numeroDoPontoDeServico),
        boxX2 + colWidth17,
        posY,
        colWidth18,
        alturaLinha
      );
      this.adicionarCaixaTexto(
        doc,
        'N├║mero Hidr├┤metro',
        String(dadosForm.numeroDoHidrometro),
        boxX2 + colWidth17 + colWidth18,
        posY,
        colWidth19,
        alturaLinha
      );
      this.adicionarCaixaTexto(
        doc,
        'Localiza├º├úo Padr├úo',
        String(dadosForm.localizacaoDoPadrao),
        boxX2 + colWidth17 + colWidth18 + colWidth19,
        posY,
        colWidth20,
        alturaLinha
      );
      const somenteDataInstalacao = dadosForm.dataInstalacao.split(' ')[0].split('/')[2].startsWith('19')
        ? ''
        : dadosForm.dataInstalacao.split(' ')[0];
      this.adicionarCaixaTexto(
        doc,
        'Data Instala├º├úo',
        String(somenteDataInstalacao),
        boxX2 + colWidth17 + colWidth18 + colWidth19 + colWidth20,
        posY,
        colWidth21,
        alturaLinha
      );
      posY += alturaLinha;

      const colWidth22 = boxWidth * 0.2;
      const colWidth23 = boxWidth * 0.2;
      const colWidth24 = boxWidth * 0.2;
      const colWidth25 = boxWidth * 0.2;
      const colWidth26 = boxWidth * 0.2;

      this.adicionarCaixaTexto(
        doc,
        'Situa├º├úo ├ügua',
        String(dadosForm.situacaoDoImovelAgua),
        boxX2,
        posY,
        colWidth22,
        alturaLinha
      );
      this.adicionarCaixaTexto(
        doc,
        'Situa├º├úo Esgoto',
        String(dadosForm.situacaoDoImovelEsgoto),
        boxX2 + colWidth22,
        posY,
        colWidth23,
        alturaLinha
      );
      this.adicionarCaixaTexto(
        doc,
        'Situa├º├úo do PS',
        String(dadosForm.situacaoDoPS),
        boxX2 + colWidth22 + colWidth23,
        posY,
        colWidth24,
        alturaLinha
      );
      this.adicionarCaixaTexto(
        doc,
        'Consumo M├®dio PS',
        String(dadosForm.consumoMedioNoPs || '0'),
        boxX2 + colWidth22 + colWidth23 + colWidth24,
        posY,
        colWidth25,
        alturaLinha
      );
      this.adicionarCaixaTexto(
        doc,
        'Ramo de Atividade',
        String(dadosForm.ramoDeAtividadePrincipal),
        boxX2 + colWidth22 + colWidth23 + colWidth24 + colWidth25,
        posY,
        colWidth26,
        alturaLinha
      );
      posY += alturaLinha + 15;
      //#endregion
      //#region Gerar Tabelas

      //Titulo tabelas
      let posYTabela = posY + 5;
      const tableWidth = 240;
      const spacing = 10;
      const addTitleBox = (title: string, x: number, y: number, titleWidth: number = tableWidth) => {
        const boxHeight = 14;
        doc.setDrawColor(0, 0, 0);
        doc.setLineWidth(0.5);
        doc.setFillColor(242, 242, 242);
        doc.rect(x, y, titleWidth, boxHeight, 'F');
        doc.setDrawColor(169, 169, 169);
        doc.setLineWidth(0.5);
        doc.rect(x, y, titleWidth, boxHeight);
        doc.setTextColor(1, 130, 214);
        doc.setFontSize(8);
        doc.text(title, x + 5, y + 10);
      };

      // Tabela da ESQUERDA (EconomCategoria)
      posYTabela;
      addTitleBox('Economia por Categoria', 40, posYTabela);
      posYTabela += 14;
      autoTable(doc, {
        head: [['TPS', 'Com.', 'Ind.', 'P├║b.', 'Res.', 'Soc.']],
        body: TableEconomCategoria,
        startY: posYTabela,
        margin: { left: 40 },
        theme: 'grid',
        styles: {
          fontSize: 8,
          cellPadding: 4,
          textColor: [0, 0, 0],
          lineColor: [169, 169, 169],
          lineWidth: 0.5,
          fontStyle: 'bold',
        },
        headStyles: {
          fillColor: [255, 255, 255],
          textColor: [1, 130, 214],
          fontStyle: 'bold',
        },
        columnStyles: {
          0: { cellWidth: 45 },
          1: { cellWidth: 39 },
          2: { cellWidth: 39 },
          3: { cellWidth: 39 },
          4: { cellWidth: 39 },
          5: { cellWidth: 39 },
        },
      });

      // Tabela da DIREITA (dadosMat)
      addTitleBox('Resumo de Situa├º├úo PS', 40 + tableWidth + spacing + 25, posYTabela - 14);
      autoTable(doc, {
        head: [['TPS', 'Situa├º├úo PS', 'Quantidade']],
        body: tableResumoPS,
        startY: posYTabela,
        margin: { left: 40 + tableWidth + spacing + 25 },
        theme: 'grid',
        styles: {
          fontSize: 8,
          cellPadding: 4,
          textColor: [0, 0, 0],
          lineColor: [169, 169, 169],
          lineWidth: 0.5,
          fontStyle: 'bold',
        },
        headStyles: {
          fillColor: [255, 255, 255],
          textColor: [1, 130, 214],
          fontStyle: 'bold',
        },
        columnStyles: {
          0: { cellWidth: 80 },
          1: { cellWidth: 80 },
          2: { cellWidth: 80 },
        },
      });

      const tabelaResumoPSHeight = doc.lastAutoTable.finalY - posYTabela + 20;
      let alturaResumoPS = 0;

      if (tableResumoPS.length === 0) {
        alturaResumoPS = 70;
      } else if (tableResumoPS.length === 1) {
        alturaResumoPS = 70;
      } else {
        alturaResumoPS = tabelaResumoPSHeight;
      }

      posYTabela = Math.max(posYTabela + alturaResumoPS, doc.lastAutoTable.finalY + 10);

      addTitleBox('Leitura do Im├│vel', 40, posYTabela, 515);
      posYTabela += 14;
      autoTable(doc, {
        head: [['M├¬s/Ano', 'Data Leitura', 'CF', 'Volume Faturado', 'Leitura', 'CA', 'Ocorr├¬ncia']],
        body: tableLeituraImovel,
        startY: posYTabela,
        margin: { left: 40 },
        theme: 'grid',
        styles: {
          fontSize: 8,
          cellPadding: 4,
          textColor: [0, 0, 0],
          lineColor: [169, 169, 169],
          lineWidth: 0.5,
          fontStyle: 'bold',
        },
        headStyles: {
          fillColor: [255, 255, 255],
          textColor: [1, 130, 214],
          fontStyle: 'bold',
        },
      });

      //Informa├º├Áes Adicionais
      posYTabela = Math.max(doc.lastAutoTable.finalY, doc.lastAutoTable.finalY) + 20;

      addTitleBox('Informa├º├Áes Adicionais', 40, posYTabela, 515);
      posYTabela += 14;
      autoTable(doc, {
        body: TableInfoAdicional,
        startY: posYTabela,
        margin: { left: 40 },
        theme: 'grid',
        styles: {
          fontSize: 8,
          cellPadding: 4,
          textColor: [0, 0, 0],
          lineColor: [169, 169, 169],
          lineWidth: 0.5,
          fontStyle: 'bold',
        },
        headStyles: {
          fillColor: [255, 255, 255],
          textColor: [1, 130, 214],
          fontStyle: 'bold',
        },
      });

      // Tabela D├®bitos
      posYTabela = Math.max(doc.lastAutoTable.finalY, doc.lastAutoTable.finalY) + 20;

      addTitleBox('D├®bitos', 40, posYTabela, 515);
      posYTabela += 14;
      autoTable(doc, {
        head: [['M├¬s/Ano Refer├¬ncia', 'Vencimento', 'Valor']],
        body: tableDebitos,
        startY: posYTabela,
        margin: { left: 40 },
        theme: 'grid',
        styles: {
          fontSize: 8,
          cellPadding: 4,
          textColor: [0, 0, 0],
          lineColor: [169, 169, 169],
          lineWidth: 0.5,
          fontStyle: 'bold',
        },
        headStyles: {
          fillColor: [255, 255, 255],
          textColor: [1, 130, 214],
          fontStyle: 'bold',
        },
      });

      // Dados da Baixa
      posYTabela = Math.max(doc.lastAutoTable.finalY, doc.lastAutoTable.finalY) + 20;

      addTitleBox('Dados da Baixa', 40, posYTabela, 515);
      posYTabela += 14;
      autoTable(doc, {
        head: [['Perguntas', 'Respostas']],
        body: tableChecklist,
        startY: posYTabela,
        margin: { left: 40 },
        theme: 'grid',
        styles: {
          fontSize: 8,
          cellPadding: 4,
          textColor: [0, 0, 0],
          lineColor: [169, 169, 169],
          lineWidth: 0.5,
          fontStyle: 'bold',
        },
        headStyles: {
          fillColor: [255, 255, 255],
          textColor: [1, 130, 214],
          fontStyle: 'bold',
        },
      });

      // Materiais Aplicados
      posYTabela = Math.max(doc.lastAutoTable.finalY, doc.lastAutoTable.finalY) + 20;

      addTitleBox('Aplica├º├Áes de Materiais', 40, posYTabela, 515);
      posYTabela += 14;
      autoTable(doc, {
        head: [['C├│digo Material', 'Descri├º├úo', 'Quantidade', 'Unidade']],
        body: tableAtividadeMat,
        startY: posYTabela,
        margin: { left: 40 },
        theme: 'grid',
        styles: {
          fontSize: 8,
          cellPadding: 4,
          textColor: [0, 0, 0],
          lineColor: [169, 169, 169],
          lineWidth: 0.5,
          fontStyle: 'bold',
        },
        headStyles: {
          fillColor: [255, 255, 255],
          textColor: [1, 130, 214],
          fontStyle: 'bold',
        },
      });

      // Servi├ºos Aplicados
      posYTabela = Math.max(doc.lastAutoTable.finalY, doc.lastAutoTable.finalY) + 20;

      addTitleBox('Aplica├º├Áes de Servi├ºos', 40, posYTabela, 515);
      posYTabela += 14;
      autoTable(doc, {
        head: [
          [
            'Local',
            'Pavimenta├º├úo',
            'Com.',
            'Lar.',
            'Pro.',
            'Pro. PL',
            'Pro. Rede',
            'Pro. PV',
            'Reaterro',
            'Observa├º├úo',
          ],
        ],
        body: tableServAplicados,
        startY: posYTabela,
        margin: { left: 40 },
        theme: 'grid',
        styles: {
          fontSize: 8,
          cellPadding: 4,
          textColor: [0, 0, 0],
          lineColor: [169, 169, 169],
          lineWidth: 0.5,
          fontStyle: 'bold',
        },
        headStyles: {
          fillColor: [255, 255, 255],
          textColor: [1, 130, 214],
          fontStyle: 'bold',
        },
      });

      // Assinatura - Provavelmente os dados vir├úo por checklist
      posYTabela = Math.max(doc.lastAutoTable.finalY, doc.lastAutoTable.finalY) + 20;

      posYTabela += 10;
      autoTable(doc, {
        head: [['Assinaturas']],
        body: tableAssinaturas,
        startY: posYTabela,
        margin: { left: 40 },
        theme: 'grid',
        styles: {
          fontSize: 8,
          cellPadding: 4,
          textColor: [0, 0, 0],
          lineColor: [169, 169, 169],
          lineWidth: 0.5,
          fontStyle: 'bold',
        },
        headStyles: {
          fillColor: [255, 255, 255],
          textColor: [1, 130, 214],
          fontStyle: 'bold',
        },
      });

      //#endregion

      doc.save(`REL_SERVICOS_${dadosForm.numeroBA}_${moment(new Date()).format('yyyyMMDD')}.pdf`);
    });
  }

  //#region Titulo personalizado para as tabelas
  private adicionarCaixaTexto(
    doc: jsPDF,
    label: string,
    valor: string,
    x: number,
    y: number,
    width: number,
    alturaLinha: number
  ) {
    const padding = 4;
    const marginTopTitulo = 10;
    const marginTopDado = 12;
    const marginLeftTitulo = 4;

    doc.setFontSize(8);
    doc.setFont('Helvetica', 'bold');
    doc.setTextColor(1, 130, 214);
    doc.text(label + ':', x + marginLeftTitulo, y + marginTopTitulo);

    doc.setFont('Helvetica', 'bold');
    doc.setTextColor(0, 0, 0);

    const textoComPadding = width - padding * 2;
    doc.text(String(valor) || '', x + padding, y + marginTopTitulo + marginTopDado, {
      maxWidth: textoComPadding,
    });

    doc.rect(x, y - 5, width, alturaLinha);
  }
  //#endregion
  loadImage(imagePath: string, larguraMaxima = 240): Promise<string> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.src = imagePath;
      img.onload = () => {
        const escala = Math.min(1, larguraMaxima / img.width);
        const canvas = document.createElement('canvas');
        canvas.width = Math.round(img.width * escala);
        canvas.height = Math.round(img.height * escala);
        const ctx = canvas.getContext('2d');
        ctx?.drawImage(img, 0, 0, canvas.width, canvas.height);
        resolve(canvas.toDataURL('image/png'));
      };
      img.onerror = () => reject('Erro ao carregar imagem');
    });
  }

  addImagesToPDF(doc: jsPDF, imgEsquerdaPath: string, imgDireitaPath: string): Promise<void> {
    return new Promise((resolve, reject) => {
      Promise.all([this.loadImage(imgEsquerdaPath), this.loadImage(imgDireitaPath)])
        .then(([imgEsquerda, imgDireita]) => {
          if (imgEsquerda) doc.addImage(imgEsquerda, 'PNG', 40, 40, 80, 22);
          if (imgDireita) doc.addImage(imgDireita, 'PNG', 478, 40, 80, 22);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}
